<servicerapport-accordion-panel [formGroup]="formGroup" title="Send e-mail til forbrugeren">
    <panel>
        <div [formGroup]="formGroup">
            <p>Forbrugeren kan vælge at få tilsendt en rapport over opgaven ved at indtaste sin e-mail nedenfor.</p>
            <dff-form-control [formControl]="formGroup.get('email.aktuel')"></dff-form-control>
            <dff-form-control [formControl]="formGroup.get('emailFrabedes.aktuel')"></dff-form-control>
        </div>
    </panel>
</servicerapport-accordion-panel>